<template>
  <div class="wrapper">
    <div style="z-index:99999;position:absolute;background:rgba(77, 77, 77, 0.336);width:100%;height:100%" v-show="Loading">
      <moon-loader style="z-index:99999;margin:300px auto;" color="#f08200" :size="75" ></moon-loader>
    </div>
    <nav class="navbar fixed-top navbar-ptc bg-ptc1">
      <router-link class="navbar-brand" :to="{ name: 'name' }">
        <img src="../assets/mwd-home-logo.svg" class="icMWDlogowhite" />
      </router-link>
      <button type="button" id="sidebarCollapse" class="btn btn-transparent navbar-item" v-on:click="toggle = !toggle">
        <i class="fas fa-bars"></i>
      </button>
      <div style="width: calc(100% - 300px);" class="text-right">
        <!-- <a href="https://devbusiness.happyclick.online/?token=123" target="_blank">
          <span style="color:white;font-size: 14px;margin-bottom:0px;height: 29px;vertical-align:bottom;">商城</span>
          <i class="fas fa-sign-in-alt" style="color:white;font-size: 14px; margin-right:30px"></i>
        </a> -->
        <b-dropdown id="navbar-ddown" :text="LoginUserName">
          <b-dropdown-item @click="showModal">變更密碼</b-dropdown-item>
          <b-dropdown-item @click="showLogOut">登出</b-dropdown-item>
        </b-dropdown>
            <b-modal ref="myModalRef" hide-footer title="變更密碼">
              <vue-form class="form-horizontal form-validation" :state="formstate" @submit.prevent="onSubmit">
              <div class="d-block text-center" style="margin-bottom: 12px;">
                <validate tag="div">
                <b-row class="my-1">
                  <b-col sm="4"><label>請輸入舊密碼︰</label></b-col>
                  <b-col sm="8">
                    <b-form-input id="Input_oldPassword" type="password" name="Input_oldPassword" v-model="old_password" required minlength="6" maxlength="12"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="4"></b-col>
                  <field-messages name="Input_oldPassword" show="$invalid && $submitted" class="text-danger">
                    <div slot="required">&nbsp;&nbsp;&nbsp;&nbsp;請輸入舊密碼</div>
                    <div slot="minlength">&nbsp;&nbsp;&nbsp;&nbsp;密碼長度限6~12位</div>
                  </field-messages>
                </b-row>
                </validate>
                <validate tag="div">
                <b-row class="my-1">
                  <b-col sm="4"><label>請輸入新密碼︰</label></b-col>
                  <b-col sm="8">
                    <b-form-input id="InputPassword" type="password" name="InputPassword" v-model="password" required minlength="6" maxlength="12"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="4"></b-col>
                  <field-messages name="InputPassword" show="$invalid && $submitted" class="text-danger">
                    <div v-if='v_pwd1 && v_pwd2 && v_pwd3' slot="required">&nbsp;&nbsp;&nbsp;&nbsp;請輸入新密碼</div>
                    <div v-if='v_pwd1 && v_pwd2 && v_pwd3' slot="minlength">&nbsp;&nbsp;&nbsp;&nbsp;密碼長度限6~12位</div>
                  </field-messages>
                  <div class="text-danger" style="padding: 0.3rem" v-if="v_pwd1 === false">&nbsp;&nbsp;&nbsp;密碼必須有英文+數字</div>
                  <div class="text-danger" style="padding: 0.3rem" v-if="v_pwd2 === false">&nbsp;&nbsp;&nbsp;密碼不可有全形字元</div>
                  <div class="text-danger" style="padding: 0.3rem" v-if="v_pwd3 === false">&nbsp;&nbsp;&nbsp;新舊密碼不可重複</div>
                </b-row>
                </validate>
                <validate tag="div">
                <b-row class="my-1">
                  <b-col sm="4"><label>再次確認密碼︰</label></b-col>
                  <b-col sm="8">
                    <b-form-input id="InputRepeatPassword" type="password" name="InputRepeatPassword" v-model="repeatPassword" required minlength="6" maxlength="12" :sameas="password"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-1">
                  <b-col sm="4"></b-col>
                  <field-messages name="InputRepeatPassword" show="$invalid && $submitted" class="text-danger">
                    <div slot="required">&nbsp;&nbsp;&nbsp;&nbsp;請輸入確認密碼</div>
                    <div slot="sameas">&nbsp;&nbsp;&nbsp;&nbsp;密碼與確認密碼不符</div>
                  </field-messages>
                </b-row>
                </validate>
              </div>
              <div class="d-block text-right">
                <b-btn variant='primary' type="submit">確認</b-btn>
                <b-btn variant='secondary' type="reset" @click="hideModal">取消</b-btn>
              </div>
              </vue-form>
            </b-modal>
            <b-modal ref="logOutRef" hide-footer title="登出">
              <vue-form class="form-horizontal form-validation" :state="formstateout" @submit.prevent="onSubmitOut">
              <div class="d-block text-center" style="margin-bottom: 12px;">
                <validate tag="div">
                <span>確定要登出</span>
                </validate>
              </div>
              <div class="d-block text-right">
                <b-btn variant='primary' type="submit">確認</b-btn>
                <b-btn variant='secondary' type="reset" @click="hideLogOut">取消</b-btn>
              </div>
              </vue-form>
            </b-modal>
      </div>
    </nav>
    <!-- Sidebar  -->
    <nav id="sidebar" v-bind:class="{ 'active': toggle }">
      <VuePerfectScrollbar class="scroll-area" v-once :settings="settings" @ps-scroll-y="scrollHanle">
        <ul class="list-unstyled components">
          <li v-if="sA02">
            <b-link href="#" v-b-toggle.homeSubmenu aria-expanded="false">
              <i class="far fa-lightbulb"></i>
              <span class="sub-menu">行銷活動</span>
            </b-link>
            <b-collapse class="list-unstyled" id="homeSubmenu" accordion="my-accordion">
              <li v-if="sF04">
                <router-link class="nav-link" :to="{ name: 'advertising_list' }">
                  <i class="fas fa-audio-description"></i>
                  <span class="menu-item">首頁廣告管理</span>
                </router-link>
              </li>
              <li v-if="sF05">
                <router-link class="nav-link" :to="{ name: 'event_list' }">
                  <i class="fas fa-shopping-bag"></i>
                  <span class="menu-item">行銷活動管理</span>
                </router-link>
              </li>
              <li v-if="sF06">
                <router-link class="nav-link" :to="{ name: 'activity_list' }">
                  <i class="fas fa-birthday-cake"></i>
                  <span class="menu-item">會員集點任務管理</span>
                </router-link>
              </li>
              <li v-if="sF38">
                <router-link class="nav-link" :to="{ name: 'survey_list' }">
                  <i class="fas fa-clipboard"></i>
                  <span class="menu-item">滿意度調查管理</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li v-if="sA04">
            <b-link href="#" v-b-toggle.storeSubmenu aria-expanded="false">
              <i class="fa fa-flag"></i>
              <span class="sub-menu">門市服務</span>
            </b-link>
            <b-collapse class="list-unstyled" id="storeSubmenu" accordion="my-accordion">
              <li v-if="sF09">
                <router-link class="nav-link" :to="{ name: 'store_menu_list' }">
                  <i class="fas fa-book-open"></i>
                  <span class="menu-item">餐點 DM 上傳</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li v-if="sA05">
            <b-link href="#" v-b-toggle.couponSubmenu aria-expanded="false">
              <i class="fa fa-trophy"></i>
              <span class="sub-menu">點數兌換券上架</span>
            </b-link>
            <b-collapse class="list-unstyled" id="couponSubmenu" accordion="my-accordion">
              <li v-if="sF10">
                <router-link class="nav-link" :to="{ name: 'coupon_exchange_list' }">
                  <i class="fas fa-money-bill"></i>
                  <span class="menu-item">商品券上架</span>
                </router-link>
              </li>
              <li v-if="sF31">
                <router-link class="nav-link" :to="{ name: 'coupon_give_list' }">
                  <i class="fas fa-money-bill"></i>
                  <span class="menu-item">商品券贈送</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li v-if="sA08">
            <b-link href="#" v-b-toggle.orderSubmenu aria-expanded="false">
              <i class="fa fa-cog"></i>
              <span class="sub-menu">線上點餐管理</span>
            </b-link>
            <b-collapse class="list-unstyled" id="orderSubmenu" accordion="my-accordion">
              <li v-if="sF16">
                <router-link class="nav-link" :to="{ name: 'product_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">POS商品管理</span>
                </router-link>
              </li>
              <li v-if="sF17">
                <router-link class="nav-link" :to="{ name: 'pos_combo_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">POS套餐管理</span>
                </router-link>
              </li>
              <!-- <li v-if="sF17">
                <router-link class="nav-link" :to="{ name: 'combo_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">套餐管理</span>
                </router-link>
              </li> -->
              <li v-if="sF18">
                <router-link class="nav-link" :to="{ name: 'menu_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">商品分類設定</span>
                </router-link>
              </li>
              <li v-if="sF19">
                <router-link class="nav-link" :to="{ name: 'plus_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">商品加購設定</span>
                </router-link>
              </li>
              <li v-if="sF20">
                <router-link class="nav-link" :to="{ name: 'ordersetting_daytypesetting' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">接單時段管理</span>
                </router-link>
              </li>
              <li v-if="sF34">
                <router-link class="nav-link" :to="{ name: 'storeholiday_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">店休設定</span>
                </router-link>
              </li>
              <li v-if="sF27 || sF39">
                <router-link class="nav-link" :to="{ name: sF27 ? 'store_list' : 'store_payment_memo' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">分店MID設定</span>
                </router-link>
              </li>
              <li v-if="sF28">
                <router-link class="nav-link" :to="{ name: 'flavor_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">調味管理</span>
                </router-link>
              </li>
              <li v-if="sF30">
                <router-link class="nav-link" :to="{ name: 'extra_list' }">
                  <i class="fa fa-cog"></i>
                  <span class="menu-item">加料品管理</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li v-if="sA09">
            <b-link href="#" v-b-toggle.orderManageSubmenu aria-expanded="false">
              <i class="fa fa-users"></i>
              <span class="sub-menu">訂單管理</span>
            </b-link>
            <b-collapse class="list-unstyled" id="orderManageSubmenu" accordion="my-accordion">
              <li v-if="sF32">
                <router-link class="nav-link" :to="{ name: 'order_manage_list' }">
                  <i class="fas fa-user-circle"></i>
                  <span class="menu-item">訂單查詢</span>
                </router-link>
              </li>
              <li v-if="sF35">
                <router-link class="nav-link" :to="{ name: 'order_period_list' }">
                  <i class="fas fa-search-plus"></i>
                  <span class="menu-item">餐期查詢</span>
                </router-link>
              </li>
              <li v-if="sF33">
                <router-link class="nav-link" :to="{ name: 'order_payment_list' }">
                  <i class="fas fa-wallet"></i>
                  <span class="menu-item">支付匯總數據</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li v-if="sA03">
            <b-link href="#" v-b-toggle.memberSubmenu aria-expanded="false">
              <i class="fa fa-users"></i>
              <span class="sub-menu">會員管理</span>
            </b-link>
            <b-collapse class="list-unstyled" id="memberSubmenu" accordion="my-accordion">
              <li v-if="sF07">
                <router-link class="nav-link" :to="{ name: 'member_info_list' }">
                  <i class="fas fa-user-circle"></i>
                  <span class="menu-item">會員查詢</span>
                </router-link>
              </li>
              <li v-if="sF08">
                <router-link class="nav-link" :to="{ name: 'member_recharge_list' }">
                  <i class="fas fa-wallet"></i>
                  <span class="menu-item">會員補點</span>
                </router-link>
              </li>
              <li v-if="sF36">
                <router-link class="nav-link" :to="{ name: 'member_memberPush_list' }">
                  <i class="fas fa-bell"></i>
                  <span class="menu-item">推播訊息</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li v-if="sA06">
            <b-link href="#" v-b-toggle.informationSubmenu aria-expanded="false">
              <i class="fa fa-bullhorn"></i>
              <span class="sub-menu">情報查詢</span>
            </b-link>
            <b-collapse class="list-unstyled" id="informationSubmenu" accordion="my-accordion">
              <li v-if="sF11">
                <router-link class="nav-link" :to="{ name: 'information_adHitsRate_list' }">
                  <i class="fas fa-hand-point-up"></i>
                  <span class="menu-item">廣告點擊率分析</span>
                </router-link>
              </li>
              <li v-if="sF12">
                <router-link class="nav-link" :to="{ name: 'information_points_list' }">
                  <i class="fas fa-chart-line"></i>
                  <span class="menu-item">點數分析</span>
                </router-link>
              </li>
              <li v-if="sF13">
                <router-link class="nav-link" :to="{ name: 'information_coupon_list' }">
                  <i class="fas fa-chart-pie"></i>
                  <span class="menu-item">點數兌換券分析</span>
                </router-link>
              </li>
              <li v-if="sF40">
                <router-link class="nav-link" :to="{ name: 'information_coupongive_list' }">
                  <i class="fas fa-chart-pie"></i>
                  <span class="menu-item">贈券分析</span>
                </router-link>
              </li>
              <li v-if="sF14">
                <router-link class="nav-link" :to="{ name: 'information_activity_list' }">
                  <i class="fas fa-chart-bar"></i>
                  <span class="menu-item">活動任務分析</span>
                </router-link>
              </li>
              <li v-if="sF21">
                <router-link class="nav-link" :to="{ name: 'information_memberusecoupon_list' }">
                  <i class="fas fa-chart-bar"></i>
                  <span class="menu-item">會員使用優惠券分析</span>
                </router-link>
              </li>
              <li v-if="sF22">
                <router-link class="nav-link" :to="{ name: 'information_apporder_list' }">
                  <i class="fas fa-chart-bar"></i>
                  <span class="menu-item">APP訂購餐點分析</span>
                </router-link>
              </li>
              <li v-if="sF25">
                <router-link class="nav-link" :to="{ name: 'information_memberAppOrder_list' }">
                  <i class="fas fa-chart-pie"></i>
                  <span class="menu-item">會員APP訂餐分析</span>
                </router-link>
              </li>
              <li v-if="sF26">
                <router-link class="nav-link" :to="{ name: 'information_areaOrder_list' }">
                  <i class="fas fa-chart-line"></i>
                  <span class="menu-item">地區訂購餐點查詢</span>
                </router-link>
              </li>
              <li v-if="sF23">
                <router-link class="nav-link" :to="{ name: 'information_payment_list' }">
                  <i class="fas fa-chart-bar"></i>
                  <span class="menu-item">第三方支付訂單查詢</span>
                  </router-link>
              </li>
               <li v-if="sF24">
                <router-link class="nav-link" :to="{ name: 'information_payforuse_list' }">
                  <i class="fas fa-chart-pie"></i>
                  <span class="menu-item">支付使用數據統計</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li v-if="sA07">
            <b-link href="#" v-b-toggle.qaSubmenu aria-expanded="false">
              <i class="fa fa-cog"></i>
              <span class="sub-menu">常見問題</span>
            </b-link>
            <b-collapse class="list-unstyled" id="qaSubmenu" accordion="my-accordion">
              <li v-if="sF15">
                <router-link class="nav-link" :to="{ name: 'qa_setting' }">
                  <i class="fas fa-user-lock"></i>
                  <span class="menu-item">常見問題設定</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li  v-if="sA01">
            <b-link href="#" v-b-toggle.systemSubmenu aria-expanded="false">
              <i class="fa fa-cog"></i>
              <span class="sub-menu">系統管理</span>
            </b-link>
            <b-collapse class="list-unstyled" id="systemSubmenu" accordion="my-accordion">
              <li v-if="sF01">
                <router-link class="nav-link" :to="{ name: 'role_management' }">
                  <i class="fas fa-user-lock"></i>
                  <span class="menu-item">權限角色管理</span>
                </router-link>
              </li>
              <li v-if="sF02">
                <router-link class="nav-link" :to="{ name: 'user_management' }">
                  <i class="fas fa-user-cog"></i>
                  <span class="menu-item">使用者管理</span>
                </router-link>
              </li>
              <li v-if="sF03">
                <router-link class="nav-link" :to="{ name: 'mail_server_setting' }">
                  <i class="fas fa-envelope"></i>
                  <span class="menu-item">Mail Server管理</span>
                </router-link>
              </li>
              <li v-if="sF29">
                <router-link class="nav-link" :to="{ name: 'system_version' }">
                  <i class="fas fa-envelope"></i>
                  <span class="menu-item">App版本管理</span>
                </router-link>
              </li>
            </b-collapse>
          </li>
          <li  v-if="sA10">
            <b-link @click="tohappy">
              <i class="fas fa-cart-arrow-down"></i>
              <span class="sub-menu">商城</span>
            </b-link>
          </li>
        </ul>
        <div>版號：{{this.version}}</div>
      </VuePerfectScrollbar>
    </nav>
    <!-- Page Content  -->
    <div id="content" v-bind:class="{ 'active': toggle }">
      <router-view/>
    </div>
  </div>
</template>
<script src="node_modules/vue/dist/vue.js"></script>
<script src="build/bundle.js"></script>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import axios from 'axios'
import {API_URL,PREORDER_URL} from '../store/root.js'
import {Version} from '../store/root.js'
// 驗證
import Vue from 'vue'
import VueForm from 'vue-form'
import options from '../js/validations.js'
import IdleVue from 'idle-vue'

import miniToastr from 'mini-toastr'
import { VueSpinners } from '@saeris/vue-spinners'

Vue.use(VueSpinners)
miniToastr.init()
// 驗證
const eventsHub = new Vue()
Vue.use(VueForm, options)
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1000 * 60 * 60 * 15 //因商城延長至15hr
})

export default {
  components: {
    VuePerfectScrollbar
  },
  name: 'home',
  onIdle () {
    this.logOut(true, true)
  },
  data () {
    return {
      settings: {},
      version: Version,
      PREORDER_URL: PREORDER_URL,
      v_pwd1: true, // 密碼驗證(英文+數字)
      v_pwd2: true, // 密碼驗證(不可有全形)
      v_pwd3: true, // 密碼驗證(新舊不可重複)
      // 1. data 這裡就是 model 存放一些資料
      // 這邊的資料與 tmplate 可以做雙向綁定
      LoginUserName: '', // 右上角登入者名字
      // 左側列表是否顯示 start
      FUNCTION: '',
      sA01: false, // 系統管理
      sA02: false, // 行銷活動
      sA03: false, // 會員管理
      sA04: false, // 門市服務
      sA05: false, // 點數兌換券上架
      sA06: false, // 情報查詢
      sA07: false, // 常見問題
      sA08: false, // 線上點餐管理
      sA09: false, // 訂單管理
      sA10: false, // 商城
      sF01: false, // 權限角色管理 (以下對照mwdGoModels\functions.go)
      sF02: false, // 使用者管理
      sF03: false, // mail server 管理
      sF04: false, // 首頁廣告管理
      sF05: false, // 行銷活動管理
      sF06: false, // 會員集點任務管理
      sF07: false, // 會員查詢
      sF08: false, // 會員補點
      sF09: false, // 餐點 DM 上傳
      sF10: false, // 商品券上架
      sF11: false, // 廣告點擊率分析
      sF12: false, // 點數分析
      sF13: false, // 點數兌換券分析
      sF14: false, // 活動任務分析
      sF15: false, // 常見問題設定
      sF16: false, // POS商品管理
      sF17: false, // 套餐管理
      sF18: false, // 商品分類設定
      sF19: false, // 商品加購設定
      sF20: false, // 接單時段管理
      sF21: false, // 會員使用優惠券分析 add 20200326 Lin_CY
      sF22: false, // APP訂購餐點分析 add 20200408 Lin_CY
      sF23: false, // 第三方支付訂單查詢 add 20200413 Lin_CY
      sF24: false, // 支付使用數據統計 add 20200420 Lin_CY
      sF25: false, // 會員APP訂餐分析
      sF26: false, // 地區訂購餐點查詢
      sF27: false, // MID設定
      sF28: false, // 調味管理
      sF29: false, // App版本管理
      sF30: false, // 加料品管理
      sF31: false, // 商品券贈送
      sF32: false, // 訂單查詢
      sF33: false, // 支付匯總數據
      sF34: false, // 店休設定
      sF35: false, // 訂單管理-餐期查詢
      sF36: false, // 會員管理-推播訊息
      sF37: false, // 商城
      sF38: false, // 行銷活動-滿意度調查管理
      sF39: false, // 線上點餐-支付方式備註
      sF40: false, // 情報分析-贈券分析
      // 左側列表是否顯示 end
      old_password: '',
      password: '',
      repeatPassword: '',
      formstate: {}, // 驗證用
      formstateout: {}, // 驗證用
      // 3. 嘗試新增一個數據
      hello: 'Hello Vue 2.0 !',

      // 7. checkbox 預設是 false
      toggle: false,
      Loading: false
    }
  },
  created () {
    this.LoginUserName = localStorage.getItem('LoginUserName')
    console.log('LoginUserName' + this.LoginUserName)
    var A01, A02, A03, A04, A05, A06, A07, A08, A09, A10 = false
    var F01 = false
    var F02 = false
    var F03 = false
    var F04 = false
    var F05 = false
    var F06 = false
    var F07 = false
    var F08 = false
    var F09 = false
    var F10 = false
    var F11 = false
    var F12 = false
    var F13 = false
    var F14 = false
    var F15 = false
    var F16 = false
    var F17 = false
    var F18 = false
    var F19 = false
    var F20 = false
    var F21 = false // add 20200326 Lin_CY
    var F22 = false // add 20200408 Lin_CY
    var F23 = false // add 20200413 Lin_CY
    var F24 = false // add 20200420 Lin_CY
    var F25 = false
    var F26 = false
    var F27 = false
    var F28 = false
    var F29 = false
    var F30 = false
    var F31 = false
    var F32 = false
    var F33, F34, F35, F36, F37 = false
    var F38 = false // 滿意度調查管理頁面
    var F39 = false // 支付方式備註
    var F40 = false // 贈券分析
    if (localStorage.getItem('FUNCTION') !== 'undefined') {
      this.FUNCTION = JSON.parse(localStorage.getItem('FUNCTION'))
      this.FUNCTION.forEach(function (arrRole, Index) {
        if (arrRole.functionCode === 'F01' && arrRole.functionPermission > 0) {
          A01 = true
          F01 = true
        }
        if (arrRole.functionCode === 'F02' && arrRole.functionPermission > 0) {
          A01 = true
          F02 = true
        }
        if (arrRole.functionCode === 'F03' && arrRole.functionPermission > 0) {
          A01 = true
          F03 = true
        }
        if (arrRole.functionCode === 'F04' && arrRole.functionPermission > 0) {
          A02 = true
          F04 = true
        }
        if (arrRole.functionCode === 'F05' && arrRole.functionPermission > 0) {
          A02 = true
          F05 = true
        }
        if (arrRole.functionCode === 'F06' && arrRole.functionPermission > 0) {
          A02 = true
          F06 = true
        }
        if (arrRole.functionCode === 'F07' && arrRole.functionPermission > 0) {
          A03 = true
          F07 = true
        }
        if (arrRole.functionCode === 'F08' && arrRole.functionPermission > 0) {
          A03 = true
          F08 = true
        }
        if (arrRole.functionCode === 'F09' && arrRole.functionPermission > 0) {
          A04 = true
          F09 = true
        }
        if (arrRole.functionCode === 'F10' && arrRole.functionPermission > 0) {
          A05 = true
          F10 = true
        }
        if (arrRole.functionCode === 'F11' && arrRole.functionPermission > 0) {
          A06 = true
          F11 = true
        }
        if (arrRole.functionCode === 'F12' && arrRole.functionPermission > 0) {
          A06 = true
          F12 = true
        }
        if (arrRole.functionCode === 'F13' && arrRole.functionPermission > 0) {
          A06 = true
          F13 = true
        }
        if (arrRole.functionCode === 'F14' && arrRole.functionPermission > 0) {
          A06 = true
          F14 = true
        }
        if (arrRole.functionCode === 'F15' && arrRole.functionPermission > 0) {
          A07 = true
          F15 = true
        }
        if (arrRole.functionCode === 'F16' && arrRole.functionPermission > 0) {
          A08 = true
          F16 = true
        }
        if (arrRole.functionCode === 'F17' && arrRole.functionPermission > 0) {
          A08 = true
          F17 = true
        }
        if (arrRole.functionCode === 'F18' && arrRole.functionPermission > 0) {
          A08 = true
          F18 = true
        }
        if (arrRole.functionCode === 'F19' && arrRole.functionPermission > 0) {
          A08 = true
          F19 = true
        }
        if (arrRole.functionCode === 'F20' && arrRole.functionPermission > 0) {
          A08 = true
          F20 = true
        }
        // s add 20200326 Lin_CY
        if (arrRole.functionCode === 'F21' && arrRole.functionPermission > 0) {
          A06 = true
          F21 = true
        }
        // e add 20200326 Lin_CY
        // s add 20200408 Lin_CY
        if (arrRole.functionCode === 'F22' && arrRole.functionPermission > 0) {
          A06 = true
          F22 = true
        }
        // e add 20200408 Lin_CY
        // s add 20200413 Lin_CY
        if (arrRole.functionCode === 'F23' && arrRole.functionPermission > 0) {
          A06 = true
          F23 = true
        }
        // e add 20200413 Lin_CY
        // s add 20200420 Lin_CY
        if (arrRole.functionCode === 'F24' && arrRole.functionPermission > 0) {
          A06 = true
          F24 = true
        }
        // e add 20200420 Lin_CY
        if (arrRole.functionCode === 'F25' && arrRole.functionPermission > 0) {
          A06 = true
          F25 = true
        }
        if (arrRole.functionCode === 'F26' && arrRole.functionPermission > 0) {
          A06 = true
          F26 = true
        }
        if (arrRole.functionCode === 'F27' && arrRole.functionPermission > 0) {
          A08 = true
          F27 = true
        }
        if (arrRole.functionCode === 'F28' && arrRole.functionPermission > 0) {
          A08 = true
          F28 = true
        }
        if (arrRole.functionCode === 'F29' && arrRole.functionPermission > 0) {
          A01 = true
          F29 = true
        }
        if (arrRole.functionCode === 'F30' && arrRole.functionPermission > 0) {
          A08 = true
          F30 = true
        }
        // 20210103 add
        if (arrRole.functionCode === 'F31' && arrRole.functionPermission > 0) {
          A05 = true
          F31 = true
        }
        // 20211007 add
        if (arrRole.functionCode === 'F32' && arrRole.functionPermission > 0) {
          A09 = true
          F32 = true
        }
        // 20211007 add
        if (arrRole.functionCode === 'F33' && arrRole.functionPermission > 0) {
          A09 = true
          F33 = true
        }
        if (arrRole.functionCode === 'F34' && arrRole.functionPermission > 0) {
          A08 = true
          F34 = true
        }
        // 20230427 add
        if (arrRole.functionCode === 'F35' && arrRole.functionPermission > 0) {
          A09 = true
          F35 = true
        }
        // 20230504 add
        if (arrRole.functionCode === 'F36' && arrRole.functionPermission > 0) {
          A03 = true
          F36 = true
        }
        // 20241119 add
        if (arrRole.functionCode === 'F37' && arrRole.functionPermission > 0) {
          A10 = true
          F37 = true
        }
        // 20251212 add
        if (arrRole.functionCode === 'F38' && arrRole.functionPermission > 0) {
          A02 = true
          F38 = true
        }
        // 支付方式備註
        if (arrRole.functionCode === 'F39' && arrRole.functionPermission > 0) {
          A08 = true
          F39 = true
        }
        // 20260514 add 情報分析 - 贈券分析
        if (arrRole.functionCode === 'F40' && arrRole.functionPermission > 0) {
          A06 = true
          F40 = true
        }
        // console.log('getFunction' + arrRole.functionId)
      })
      this.sA01 = A01
      this.sA02 = A02
      this.sA03 = A03
      this.sA04 = A04
      this.sA05 = A05
      this.sA06 = A06
      this.sA07 = A07
      this.sA08 = A08
      this.sA09 = A09
      this.sA10 = A10
      this.sF01 = F01
      this.sF02 = F02
      this.sF03 = F03
      this.sF04 = F04
      this.sF05 = F05
      this.sF06 = F06
      this.sF07 = F07
      this.sF08 = F08
      this.sF09 = F09
      this.sF10 = F10
      this.sF11 = F11
      this.sF12 = F12
      this.sF13 = F13
      this.sF14 = F14
      this.sF15 = F15
      this.sF16 = F16
      this.sF17 = F17
      this.sF18 = F18
      this.sF19 = F19
      this.sF20 = F20
      this.sF21 = F21
      this.sF22 = F22
      this.sF23 = F23
      this.sF24 = F24
      this.sF25 = F25
      this.sF26 = F26
      this.sF27 = F27
      this.sF28 = F28
      this.sF29 = F29
      this.sF30 = F30
      this.sF31 = F31
      this.sF32 = F32
      this.sF33 = F33
      this.sF34 = F34
      this.sF35 = F35
      this.sF36 = F36
      this.sF37 = F37
      this.sF38 = F38
      this.sF39 = F39
      this.sF40 = F40
    }
  },
  methods: {
    scrollHanle() {
    },
    verificationErrMsg() {
      miniToastr.error('畫面未輸入正確，請檢視下方提示訊息')
    },
    logOut (clearDBToken, showJWTOutMsg) {
      if (clearDBToken) {
        var id = 0
        if (!isNaN(localStorage.getItem('LoginUserID'))) {
          id = Number(localStorage.getItem('LoginUserID'))
        }
        axios.post(API_URL + '/web/signout/v1', {
          id: id
        })
      }
      localStorage.setItem('COMPANY', 0)
      localStorage.setItem('TOKEN', '')
      localStorage.setItem('LoginUserName', '')
      localStorage.setItem('LoginUserID', 0)
      localStorage.setItem('FUNCTION', '')
      localStorage.setItem('LOADING', false)
      this.$router.push('/login')
      if (showJWTOutMsg) {
        miniToastr.error('帳號重複登入，請重新登入')
      }
    },
    onSubmit: function () {
      this.v_pwd1 = true // 有英文+數字
      this.v_pwd2 = true // 半形
      this.v_pwd3 = true // 新舊
      if (this.password != '' && this.password.length > 6)
      {
        if (/[a-zA-Z]/.test(this.password) && /[0-9]/.test(this.password)) {
          this.v_pwd1 = true // 有英文+數字
          if (/[\uFF00-\uFFFF]/.test(this.password) || /[\u4E00-\u9fa5]/.test(this.password)) { // 全形、中文
            this.v_pwd2 = false // 全形
          } else {
            this.v_pwd2 = true // 半形
          }
        } else {
          this.v_pwd1 = false // 不符合英文+數字
        }
        if (this.v_pwd1 && this.v_pwd2) {
          if (this.password === this.old_password) {
            this.v_pwd3 = false
          }
        }
      }
      if (this.formstate.$invalid || this.v_pwd1 === false || this.v_pwd2 === false || this.v_pwd3 === false) {
      } else {
        this.edit()
      }
    },
    showModal () {
      this.formstate.$submitted = false
      this.old_password = ''
      this.password = ''
      this.repeatPassword = ''
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.old_password = ''
      this.password = ''
      this.repeatPassword = ''
      this.$refs.myModalRef.hide()
    },
    edit () {
      return axios.post(API_URL + '/web/user/page/edit_pwd', {
        Password: this.password,
        oldPassword: this.old_password
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('修改成功')
            this.hideModal()
          } else if (response.data.result === '0014') {
            miniToastr.error('舊密碼輸入錯誤，請重新輸入', '錯誤訊息')
          } else if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })
    },
    showLogOut () {
      this.$refs.logOutRef.show()
    },
    hideLogOut () {
      this.$refs.logOutRef.hide()
    },
    onSubmitOut: function () {
      this.logOut(true, false)
    },
    tohappy () {
      window.open(this.PREORDER_URL+'?token='+localStorage.getItem('TOKEN'),'_blank')
      /*return axios.post(API_URL + '/web/user/getPreOrderToken/v1')
        .then((response) => {
          if (response.data.result === '0000') {
            console.log(response.data.data.userToken)
            window.open('https://devbusiness.happyclick.online/?token='+response.data.data.userToken,'_blank')
          } else if (response.data.result === '0006') {
              this.$parent.logOut(false, true)
          } else {
            miniToastr.error(response.message, '錯誤訊息')
          }
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
        })*/
    }
  }
}
</script>
<style scoped>
body {
  background: #fafafa;
}
img.icMWDlogowhite {
  width: 101.7px;
  height: 37.2px;
  margin: 0 51.3px 0 0;
  object-fit: contain;
}

p {
  font-size: 1.1em;
  font-weight: 300;
  line-height: 1.7em;
  color: #999;
}

a,
a:hover,
a:focus {
  color: inherit;
  text-decoration: none;
  transition: all 0.3s;
}

.navbar {
  padding: 15px 10px;
  background: #fff;
  border: none;
  border-radius: 0;
  /* margin-bottom: 40px; */
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  display: -webkit-box;
}

.navbar-item {
  color: #519b39;
}

.navbar-btn {
  box-shadow: none;
  outline: none !important;
  border: none;
}

.line {
  width: 100%;
  height: 1px;
  border-bottom: 1px dashed #ddd;
  margin: 40px 0;
}

i,
span {
  display: inline-block;
}

.btn-transparent {
  background-color: transparent;
  background-repeat: no-repeat;
  padding: 0 !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
/* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */

.wrapper {
  display: flex;
  width: 100%;
}

#sidebar {
  width: 250px;
  position: fixed;
  padding-top: 5px;
  top: 75px;
  left: 0;
  height: 100vh;
  z-index: 998;
  background: #013925;
  /* background: #ffffff; */
  color: #fff;
  /* color: #5a0a0a; */
  transition: all 0.3s;
  -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.1);
}

#sidebar.active {
  width: 80px;
  text-align: center;
}

#sidebar .scroll-area {
  position: relative;
  margin: auto;
  width: 250px;
  height: calc(100% - 74px);
}

#sidebar.active .scroll-area {
  width: 80px;
  height: calc(100% - 73px);
}

#sidebar ul li a {
  text-align: left;
  outline: 0;
}

#sidebar.active ul li a {
  padding: 20px 10px;
  text-align: center;
  font-size: 0.85em;
}

#sidebar.active ul li a i {
  margin-right: 0;
  display: block;
  font-size: 1.8em;
  margin-bottom: 5px;
}

#sidebar.active ul ul a {
  padding: 10px !important;
}
/* #sidebar.active .dropdown-toggle::after {
    top: auto;
    bottom: 10px;
    right: 50%;
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
    transform: translateX(50%);
} */

#sidebar ul.components {
  /* padding: 20px 0; */
  border-bottom: 1px solid #519b39;
}

#sidebar ul li a {
  padding: 10px;
  font-size: 1.1em;
  display: block;
}

#sidebar ul li a:hover {
  background: #004f2d;
  /* background: #f2f2f2; */
}

#sidebar ul li a i {
  margin-right: 10px;
}

#sidebar ul li.active > a,
a[aria-expanded='true'] {
  background: #004f2d;
  /* background: #f2f2f2; */
}
/* a[data-toggle="collapse"] {
    position: relative;
} */
/* .dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
} */
/* ul .list-unstyled a {
    font-size: 0.9em !important;
    padding-left: 30px !important;
    background: #f08200;
} */

#sidebar ul .list-unstyled a {
  background: #004f2d;
  /* background: #f2f2f2; */
  /* font-size: 0.9em !important; */
  padding-left: 30px !important;
  outline: 0;
}

#sidebar.active ul .list-unstyled a {
  padding-left: 10px !important;
}

#sidebar.active .sub-menu,
#sidebar.active .menu-item {
  display: none !important;
}

a.article,
a.article:hover {
  background: #6d7fcc !important;
  color: #fff !important;
}
/* ---------------------------------------------------
    CONTENT STYLE
----------------------------------------------------- */

#content {
  width: calc(100% - 250px);
  /* padding: 40px; */
  /* min-height: 100vh; */
  transition: all 0.3s;
  position: absolute;
  top: 75px;
  right: 0;
}

#content.active {
  width: calc(100% - 80px);
  /* padding: 40px; */
  margin-left: 80px;
}
/* ---------------------------------------------------
    MEDIAQUERIES
----------------------------------------------------- */

@media (max-width: 768px) {
  #sidebar {
    min-width: 80px;
    max-width: 80px;
    text-align: center;
    margin-left: -80px !important;
  }
  /* .dropdown-toggle::after {
      top: auto;
      bottom: 10px;
      right: 50%;
      -webkit-transform: translateX(50%);
      -ms-transform: translateX(50%);
      transform: translateX(50%);
  } */
  #sidebar.active {
    margin-left: 0 !important;
  }
  #sidebar .scroll-area {
    min-width: 80px;
    max-width: 80px;
    height: calc(100% - 73px);
  }
  #sidebar ul li a {
    padding: 20px 10px;
  }
  #sidebar ul li a span {
    font-size: 0.85em;
  }
  #sidebar ul li a i {
    margin-right: 0;
    display: block;
  }
  #sidebar ul ul a {
    padding: 10px !important;
  }
  #sidebar ul li a i {
    font-size: 1.3em;
  }
  #sidebar {
    margin-left: 0;
  }
  #sidebarCollapse span {
    display: none;
  }
  #content {
    width: 100%;
    /* padding: 40px; */
    /* margin-left: 80px; */
  }
  ul .list-unstyled a {
    padding-left: 30px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue